<template>
  <div class="" v-if="isPropertyLoading">
    <Loading />
  </div>

  <div v-else>
    <BethsLayout>
      <div class="flex flex-col justify-center min-h-600">
        <!-- component -->
        <div
          class="m-auto my-10 border-2 border-gray-300 shadow-md rounded-md w-12/12 lg:w-6/12 md:w-8/12 sm:10/12"
        >
          <div class="px-8 py-8 rounded-xl">
            <h1 name="login-title" class="mt-2 text-center font-bold text-2xl">
              Set Password for {{ property.name }}
            </h1>
            <p class="my-8 text-md font-serif">
              Please set a private password for this account that you will use to login
              from this point on...
            </p>

            <ErrorDisplay
              :label="resetErrorLabel"
              :message="resetError"
              :isVisible="resetError != null"
            />

            <form action="" class="mt-6" v-if="property?.isPasswordLoginEnabled ?? true">
              <div class="my-5 text-sm">
                <!-- <div class="my-5 text-sm">
                  <BaseInput
                    label="Old Shared password"
                    id="password"
                    v-model="oldPassword"
                    type="password"
                    autocomplete="current-password"
                    placeholder="Password"
                  />
                </div> -->
              </div>
              <div class="my-5 text-sm">
                <BaseInput
                  label="New Password"
                  id="password"
                  v-model="password"
                  type="password"
                  autocomplete="current-password"
                  placeholder="Password"
                />
              </div>
              <!-- <div class="my-5 text-sm">
                <BaseInput
                  label="Confirm Password"
                  id="passwordConfirm"
                  v-model="passwordConfirm"
                  type="password"
                  placeholder="Password"
                />
              </div> -->
              <button
                id="login_button"
                class="mt-4 w-full p-3 py-6 text-center text-white duration-300 bg-gray-800 rounded-sm hover:bg-black"
                @click.prevent="setPersonalPassword"
              >
                <span>Confirm</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </BethsLayout>
  </div>
</template>
<script setup lang="ts">
import { useUserStore } from "../store/userStore";
import { useBldgStore } from "../store/bldgStore";

// Okay as IconOkta,
// Google as IconGoogle,
const userStore = useUserStore();
const bldgStore = useBldgStore();
const router = useRouter();
const route = useRoute();
var isPropertyLoading = computed(() => bldgStore.isLoading);
let isLoading = ref(false);
var property = computed(() => bldgStore.property);
onMounted(loadData);
onActivated(() => loadData);
watch(property, loadData);
async function loadData() {
  isLoading.value = true;
  if (property?.value?.portalId) {
    await router.isReady();
    let queryEmail = route.query["user"];
    if (queryEmail) email.value = Array.isArray(queryEmail) ? queryEmail[0] : queryEmail;
    let queryOldPass = route.query["oldpass"];
    if (queryOldPass)
      oldPassword.value = Array.isArray(queryOldPass) ? queryOldPass[0] : queryOldPass;
  }
  isLoading.value = false;
}
let resetErrorLabel = ref<string | null>(null);
let resetError = ref<string | null>(null);
let email = ref("");
let oldPassword = ref("");
let password = ref("");
//let passwordConfirm = ref("");
//let oldPassword = ref("");

async function setPersonalPassword() {
  console.log(`Attempting login for: ${email.value}`);
  // if (password.value !== passwordConfirm.value) {
  //   resetError.value = "Passwords do not match.";
  //   return;
  // }
  let setResult = await userStore.setPersonalPassword(
    email.value,
    oldPassword.value,
    password.value,
    property.value.portalId
  );

  if (!setResult || setResult.length === 0) {
    console.log(`Attempting login for: ${email.value}`);

    let loginResult = await userStore.loginUser(
      email.value,
      password.value,
      property.value.portalId,
      null,
      null,
      property.value.siteCode
    );
    if (loginResult && !loginResult.error) {
      if (userStore.isLoggedIn) {
        var user = await userStore.getUser(
          bldgStore.siteCode,
          bldgStore.property.portalId,
          true
        );
        if (user.token) {
          // One call covers every API client - the token is shared in ClientBase.
          userStore.setAuthToken(user.token);
        }
        router.replace("/" + property.value.siteCode);
      }
    } else {
      // if there is an error logging user in after setting password
      resetErrorLabel.value = "Couldn't log in";
      resetError.value =
        "There has been an error logging you in, please try again later.";
    }
  } else {
    // if there is an error setting new password
    resetErrorLabel.value = "Couldn't set password";
    resetError.value =
      setResult ??
      "There has been an error setting your password. Please press back, refresh and try again";
  }
}
</script>
